import { Subject } from 'rxjs';
// import { BulkView, BV } from "./bulk-view"
import { CoordinatorService } from './coordinator.service';
import { View } from './view';
import { ScriptHitset } from './script-hitset';
import { AutoUser } from './auto-user';

export class Bulk$ {
    closeAccordion$ = new Subject<void>();

    targetUser?: AutoUser;

    constructor(public coords: CoordinatorService) {}

    confirm(v: View, type: 'add' | 'delete', idLs: string[]) {
        switch (type) {
            case 'add':
                v.addIds(idLs);
                break;
            // return v.addIds(this._activeList.map(x => x.id))
            case 'delete':
                v.deleteIds(idLs);
                break;
            // return v.deleteIds(this._activeList.map(x => x.id))
        }
        this.coords.display$.markForCheck();
    }

    private get _activeList() {
        return this.coords.resultList$.activeList$.getValue();
    }

    get hitset() {
        const h = new ScriptHitset(this.coords);
        (h as ScriptHitset).idSet = new Set(this._activeList.map((x) => x.id));
        return h;
    }

    get size() {
        return this._activeList.length;
    }

    actionData(v: View) {
        let ls = this.coords.resultList$.activeList$.getValue().map((x) => x.id);

        const inLs: string[] = [];
        const outLs: string[] = [];

        if (v.id.startsWith('__toMain-')) {
            ls.forEach((x) =>
                this.coords.dataset$.fromPreview2MainId(x) ? inLs.push(x) : outLs.push(x),
            );
        } else if (v.id.startsWith('__fromMain-')) {
            ls.forEach((x) =>
                !this.coords.dataset$.fromPreview2MainId(x) ? inLs.push(x) : outLs.push(x),
            );
        } else {
            if (this.coords.stage$.current.is('preview')) {
                if (v.id.startsWith('__')) {
                    ls = ls.filter((x) => !this.coords.dataset$.fromPreview2MainId(x));
                    if (v.id.startsWith('__seen-')) {
                        const rejectView = this.coords.view$.get('__rejected')!;
                        ls = ls.filter((x) => !rejectView.has(x));
                    }
                } else {
                    ls = ls
                        .map((x) => this.coords.dataset$.fromPreview2MainId(x))
                        .filter((x) => x) as string[];
                }
            }

            ls.forEach((x) => (v.has(x) ? inLs.push(x) : outLs.push(x)));
        }
        this.coords.selection$.clear();
        return { in: inLs, out: outLs };
    }

    dialog() {
        this.coords.display$.dialog$.next({ action: 'bulk' });
    }
}
